import {put} from 'redux-saga/effects'

export default function*() {
  yield put({type: 'ERROR/CLEAR'})
}



// WEBPACK FOOTER //
// ./src/requests/sagas/clearApiError.js